export enum APPOINTMENT_ASIDE_BUTTONS {
  SEND_AND_SAVE,
  SAVE,
  INVOICE,
  CANCEL,
}
